// in src/AppBar.js
import * as React from 'react';
import { AppBar } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
    logo: {
        height: 50,
        marginBottom: -30,
      },
});

const MyAppBar = props => {
    const classes = useStyles();
    return (
        <AppBar {...props} color={'secondary'}>
            <Typography
                variant="h6"
                color="initial"
                className={classes.title}
                id="react-admin-title"
            />
            {/* <Logo /> */}
            {/* <span className={classes.spacer} /> */}
        </AppBar>
    );
};

export default MyAppBar;